const paths = new Set([
  '/test-v2-crni-petek/',
  '/crni-petek/',
  '/test-v2-black-friday/',
  '/black-friday/',
  '/kuhinje/',
  '/kuhinje-klasicne/',
  '/kuhinje-rusticne/',
  '/kuhinje-moderne/',
  '/gta-vi/',
  '/test-v2-kuhinje/',
  '/test-v2-kuhinje-klasicne/',
  '/test-v2-kuhinje-rusticne/',
  '/test-v2-kuhinje-moderne/',
  '/test-v2-gta-vi/',
]);

export function isCmsBuilderPath(path) {
  if (typeof path !== 'string') return false;
  try {
    const pathname = decodeURI(path.split(/[?#]/, 1)[0]);
    return paths.has(pathname.endsWith('/') ? pathname : pathname + '/');
  } catch { return false; }
}

export function isCmsBuilderField(field) {
  const match = typeof field === 'string' && field.match(/^[^:]+:[^:]+:(\/.*)$/);
  return Boolean(match && isCmsBuilderPath(match[1]));
}
